import { useEffect, useState } from 'react';
import Parser from 'html-react-parser';
import _ from 'lodash';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import l from '../../../../../../lang';
import { functionalCurrenciesByCountry } from "../../../../../../config";
import Input from '../../../../../common/input';
import ButtonCustom from '../../../../../common/__deprecated__/button-custom';
import Select from '../../../../../common/select';
import InputCheckbox from '../../../../../common/input-checkbox';
import Accordion from '../../../../../common/accordion';
import Message from '../../../../../common/message';
import { MessageTypes } from '../../../../../../constants';
import TooltipIcon from '../../../../../common/tooltip-icon';
import Card from '../../../../../common/card';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import NewClientFields from '../new-client-fields';
import ExistingClients from '../../../existing-clients';
import MessageError from '../../../../../common/message-error';
import { usePaymentLink } from '../../../../../../store/payment-link';
import FraudMessage from '../../../../fraud-message';
import { useDashboard } from '../../../../../../store/dashboard';

const CreateFormFields = ({
  handleSubmit,
  validateForm,
  values,
  errors,
  setFieldValue,
  touched,
  handleChange,
  handleBlur,
  scrollToFormErrors,
  setShowClientData,
  setNewClient,
  errorCardRef,
  countryRef,
  amountRef,
  currencyRef,
  clientEmailRef,
  clientDocumentRef,
  countries,
  formDisabled,
  showClientData,
  newClient,
  canOperate,
  fraudReview,
  fnGetCurrencies,
  fnGetDocumentTypes,
}: any) => {
  const { userMe, merchantMe } = useDashboard();
  const { errorInfo, currencies, documentTypes, cleanErrorPaymentLink } = usePaymentLink();
  const [ availableCurrencies, setAvailableCurrencies ] = useState(currencies);
  const [ blockCurrenciesSelect, setBlockCurrenciesSelect ] = useState(false);
  const email = !showClientData || newClient ? values.clientEmail : '';

  useEffect(() => {
    validateForm();
  }, [errorInfo]);

  useEffect(() => {
    if (!_.isEmpty(errors)) {
      scrollToFormErrors(errors);
    }
  }, [errors]);

  useEffect(() => {
    if(values.country === merchantMe?.country){
      setBlockCurrenciesSelect(false);
      setAvailableCurrencies(currencies);
      setDefaultCurrency(values.country);
    }else if(values.country){
      setBlockCurrenciesSelect(true);
      setAvailableCurrencies({USD: "USD"});
      setDefaultCurrency(values.country);
    }
  }, [currencies])


  const setDefaultCurrency = (value:string) => {
    if (availableCurrencies) {
      const cs = Object.keys(availableCurrencies);
      console.log(cs.length && !cs.filter(d => value === d).length)
      if (cs.length && !cs.filter(d => value === d).length) {
        setFieldValue('currency', cs[0]);
      }
    }
  };


  return (
    <div className="payment-card">
      <form onSubmit={handleSubmit}>
        {(errorInfo?.title || errorInfo?.message) && Object.keys(errors).length === 0 ? (
          <div ref={errorCardRef} className="create-payment-link-form__error">
            <MessageError errorInfo={errorInfo} />
          </div>
        ) : null}

        <Card>
          <div className="create-payment-link-form__container">
            {!canOperate && (
              <div className="create-payment-link-form__message">
                <Message type={MessageTypes.INFO} body={l('common.cannotOperateMessage')} />
              </div>
            )}
            <FraudMessage />
            <div className="create-payment-link-form__title">{l('paymentLink.subtitle')}</div>
            <div className="create-payment-link-form__subtitle">{l('localCurrencyWarning')}</div>
            <div ref={countryRef} className="create-payment-link-form__row">
              <div className="create-payment-link-form__field">
                <Select
                  name="country"
                  label={l('paymentLink.country')}
                  value={values.country}
                  onChange={e => {
                    fnGetCurrencies(e.target.value);
                    fnGetDocumentTypes(e.target.value);
                    setFieldValue('clientDocumentType', '');
                    setFieldValue('clientDocument', '');
                    setFieldValue('country', e.target.value);
                  }}
                  options={countries()}
                  disabled={formDisabled}
                  error={errors.country && touched.country && errors.country}
                  ref={undefined}
                  onClose={undefined}
                  onFocus={undefined}
                  onMouseOver={undefined}
                  groupOptionsArray={undefined}
                  groupOptionsArrayDisabled={undefined}
                  message={undefined}
                />
              </div>
              <div className="create-payment-link-form__info">
                <TooltipIcon
                  placement="left"
                  text={Parser(l('paymentLink.country.tooltip'))}
                  icon={<InfoIcon color="primary" />}
                />
              </div>
            </div>
            <div ref={currencyRef} className="create-payment-link-form__row">
              <div className="create-payment-link-form__field currency">
                <Select
                  name="currency"
                  label={l('paymentLink.currency')}
                  value={values.currency}
                  onChange={e => {
                    cleanErrorPaymentLink();
                    setFieldValue('currency', e.target.value);
                  }}
                  options={availableCurrencies}
                  disabled={ blockCurrenciesSelect || _.isEmpty(currencies) || !values.country || formDisabled}
                  ref={undefined}
                  groupOptionsArray={undefined}
                  groupOptionsArrayDisabled={undefined}
                  onFocus={undefined}
                  onMouseOver={undefined}
                  onClose={undefined}
                  message={undefined}
                />
              </div>
         
              <div className="create-payment-link-form__info">
                <TooltipIcon
                  placement="right"
                  text={Parser(l('paymentLink.currency.tooltip'))}
                  icon={<InfoIcon color="primary" />}
                />
              </div>
              <div ref={amountRef} className="create-payment-link-form__field create-payment-link-form__field amount">
                <Input
                  type="number"
                  name="amount"
                  label={l('paymentLink.amount')}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.amount}
                  disabled={formDisabled}
                  error={errors.amount && touched.amount && errors.amount}
                />
              </div>
            </div>
            {
              blockCurrenciesSelect && 
                merchantMe?.country && 
                  <p className='create-payment-link-form__currency-warn'>
                    {Parser(l('localCurrencyInfo', (functionalCurrenciesByCountry as {[key:string]: string})[merchantMe?.country]))}
                  </p>
            }
            <div className="create-payment-link-form__row">
              <div className="create-payment-link-form__field">
                <Input
                  name="description"
                  label={l('paymentLink.description')}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.description}
                  maxLength={100}
                  disabled={formDisabled}
                  error={errors.description && touched.description && errors.description}
                />
              </div>
              <div className="create-payment-link-form__info">
                <TooltipIcon
                  placement="left"
                  text={Parser(l('paymentLink.description.tooltip'))}
                  icon={<InfoIcon color="primary" />}
                />
              </div>
            </div>
            {(!showClientData || newClient) && (
              <div ref={clientEmailRef} className="create-payment-link-form__row">
                <div className="create-payment-link-form__field">
                  <Input
                    name="clientEmail"
                    label={l('paymentLink.clientEmail')}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={email}
                    maxLength={50}
                    disabled={formDisabled}
                    error={touched.clientEmail && errors.clientEmail}
                  />
                </div>
              </div>
            )}
            <div className="create-payment-link-form__row shrunk">
              <div className="create-payment-link-form__field">
                <InputCheckbox
                  name="sendEmail"
                  label={l('paymentLink.sendEmail')}
                  onChange={e => setFieldValue('sendEmail', e.target.checked)}
                  onBlur={handleBlur}
                  value={values.sendEmail}
                  disabled={formDisabled}
                  error={errors.sendEmail && touched.sendEmail && errors.sendEmail}
                />
              </div>
            </div>
          </div>
        </Card>

        <Accordion header={l('paymentLink.addClientData')} isExpanded={showClientData} onChange={setShowClientData}>
          <div className="create-payment-link-form__container">
            <span>{l('paymentLink.selectClient')}</span>
            <div className="create-payment-link-form__tabs">
              <Tabs
                value={newClient ? 0 : 1}
                onChange={() => {
                  setNewClient(!newClient);
                  if (!newClient) {
                    setFieldValue('clientEmail', '');
                  }
                }}
                indicatorColor="primary"
                textColor="primary"
              >
                <Tab label={<p>{l('paymentLink.newClient')}</p>} />
                <Tab label={<p>{l('paymentLink.existingClient')}</p>} />
              </Tabs>
            </div>
            {newClient ? (
              <NewClientFields
                clientFirstName={values.clientFirstName}
                clientLastName={values.clientLastName}
                clientDocumentType={values.clientDocumentType}
                clientDocument={values.clientDocument}
                clientDocumentRef={clientDocumentRef}
                documentTypes={documentTypes}
                formDisabled={formDisabled}
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                handleBlur={handleBlur}
              />
            ) : (
              <ExistingClients
                value={values.clientSelected}
                country={values.country}
                fnSelectClient={c => setFieldValue('clientSelected', c)}
                externalError={errors.clientSelected && touched.clientSelected ? errors.clientSelected : null}
              />
            )}
          </div>
        </Accordion>

        <div className="create-payment-link-form__submit_btn">
          <ButtonCustom
            name="create-payment-link"
            type="submit"
            text={l('paymentLink.create')}
            loading={formDisabled}
            onClick={() => {
              if (!_.isEmpty(errors)) {
                scrollToFormErrors(errors);
              }
            }}
          />
        </div>
      </form>
    </div>
  );
};

export default CreateFormFields;
